import React from 'react';
import { Globe, Mail, Phone } from 'lucide-react';
import { ClipPlayer } from './ClipPlayer';
import { BRAND } from './brandContent';

const Wave = () => (
  <div className="sc-wave" aria-hidden="true">
    {Array.from({ length: 24 }).map((_, i) => <span key={i} style={{ animationDelay: `${(i % 12) * 0.08}s` }} />)}
  </div>
);

export const IntroSlide = () => (
  <section className="sc-slide sc-brand sc-intro" data-testid="showcase-intro">
    <img src="/brand/audinexa-horizontal.png" alt="AudiNexa" className="sc-brand-logo sc-brand-logo-lg" />
    <p className="sc-brand-tag">Clinic management for audiology &amp; hearing care</p>
    <Wave />
    <p className="sc-brand-sub">Product walkthrough</p>
    <ClipPlayer refId="00.0" />
  </section>
);

export const OutroSlide = () => (
  <section className="sc-slide sc-brand sc-outro" data-testid="showcase-outro">
    <img src="/brand/audinexa-horizontal.png" alt="AudiNexa" className="sc-brand-logo" />
    <h2 className="sc-brand-cta" data-testid="showcase-outro-cta">Book a free demo</h2>
    <p className="sc-brand-tag">See AudiNexa running on your own clinic’s workflow.</p>
    <div className="sc-brand-contacts" data-testid="showcase-outro-contacts">
      <a href={`https://${BRAND.website}`} target="_blank" rel="noreferrer"><Globe size={20} />{BRAND.website}</a>
      <a href={BRAND.phoneHref}><Phone size={20} />{BRAND.phone}</a>
      <a href={`mailto:${BRAND.email}`}><Mail size={20} />{BRAND.email}</a>
    </div>
    <Wave />
    <ClipPlayer refId="99.0" />
  </section>
);
